import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);

                // Se estiver na página de login, redireciona para o painel
                if (window.location.pathname === '/app/login') {
                    navigate("/painel");
                }
            } catch (error) {
                localStorage.removeItem("user");
            }
        }
        setLoading(false);
    }, [navigate]);

    // Função para verificar autenticação inicial
    const checkAuth = useCallback(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
            } catch (error) {
                localStorage.removeItem("user");
            }
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const login = useCallback((userData) => {
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("user");
        setUser(null);
        navigate("/login");
    }, [navigate]);

    const isAuthenticated = useCallback(() => !!user, [user]);

    const hasRole = useCallback((role) => user?.roles?.includes(role), [user]);

    return (
        <AuthContext.Provider value={{
            user,
            loading,
            login,
            logout,
            isAuthenticated,
            hasRole
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
